import { StytchAPIError } from "@stytch/react";

export const StytchErrorType = {
  SessionTooOldToResetPassword: "session_too_old_to_reset_password", // NOSONAR
  WeakPassword: "weak_password", // NOSONAR
  BreachedPassword: "breached_password", // NOSONAR
  EmailNotFound: "email_not_found",
  UnableToAuthPasswordResetToken: "unable_to_auth_password_reset_token", // NOSONAR
  UnauthorizedCredentials: "unauthorized_credentials", // NOSONAR
  NoUserPassword: "no_user_password", // NOSONAR
} as const;

export type StytchErrorType = (typeof StytchErrorType)[keyof typeof StytchErrorType];

const STYTCH_ERROR_MESSAGES: Record<StytchErrorType, string> = {
  session_too_old_to_reset_password:
    "Sua sessão expirou. Por favor, faça login novamente para redefinir sua senha.", // NOSONAR
  unable_to_auth_password_reset_token:
    "Seu link de redefinição de senha expirou ou já foi utilizado. Por favor, solicite um novo.", // NOSONAR
  weak_password: "Sua senha é muito fraca. Por favor, escolha uma senha mais forte.", // NOSONAR
  breached_password:
    "Essa senha foi identificada em vazamentos de dados. Por favor, escolha outra.", // NOSONAR
  email_not_found:
    "Não encontramos uma conta associada a esse e-mail. Verifique o endereço e tente novamente ou realize o primeiro acesso.", // NOSONAR
  unauthorized_credentials:
    "E-mail ou senha inválidos. Verifique seus dados e tente novamente.", // NOSONAR
  no_user_password:
    'Para acessar sua conta, redefina sua senha usando a opção "Esqueci minha senha".', // NOSONAR
};

const UNAUTHORIZED_STATUS_CODE = 401;
const RESET_PASSWORD_ERROR_TYPE = "reset_password"; // NOSONAR

export const isPasswordResetTokenError = (error: unknown): error is StytchAPIError =>
  error instanceof StytchAPIError &&
  error.error_type === StytchErrorType.UnableToAuthPasswordResetToken;

export const isInvalidSessionError = (error: unknown): error is StytchAPIError =>
  error instanceof StytchAPIError && error.status_code === UNAUTHORIZED_STATUS_CODE;

export const isResetPasswordError = (error: unknown): error is StytchAPIError =>
  error instanceof StytchAPIError && error.error_type === RESET_PASSWORD_ERROR_TYPE;

export const mapStytchErrorToMessage = (error: unknown): string | null => {
  if (!(error instanceof StytchAPIError)) {
    return null;
  }

  const message = STYTCH_ERROR_MESSAGES[error.error_type as StytchErrorType];
  return message || null;
};
